import Lottie from 'lottie-react';
import { Box, Typography } from '@mui/material';
import prasaarBroadcast from '../../assets/lottie/prasaar-broadcast.json';
import { tokens } from '../../theme/tokens';
import { usePrefersReducedMotion } from '../../motion/transitions';

/**
 * Login hero — transparent over the shared dark page gradient.
 */
export function LoginHeroPanel({ compact = false }) {
  const reduceMotion = usePrefersReducedMotion();

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        minHeight: compact ? 220 : { xs: 260, sm: 300, md: '100%' },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        px: { xs: 2, sm: 3, md: 4, lg: 6 },
        py: { xs: 2.5, sm: 3, md: 4 },
        position: 'relative',
        overflow: 'hidden',
        bgcolor: 'transparent',
      }}
    >
      <Box
        sx={{
          width: '100%',
          flex: { xs: '0 0 auto', md: '1 1 auto' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: { xs: 300, sm: 360, md: 460, lg: 540 },
          minHeight: { xs: 200, sm: 240, md: 0 },
          position: 'relative',
          zIndex: 1,
          '& svg': { verticalAlign: 'middle' },
        }}
      >
        <Lottie
          animationData={prasaarBroadcast}
          loop={!reduceMotion}
          autoplay
          style={{
            width: '100%',
            height: '100%',
            maxHeight: compact ? 200 : undefined,
          }}
          rendererSettings={{ preserveAspectRatio: 'xMidYMid meet' }}
        />
      </Box>

      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          mt: { xs: 1, md: 0 },
          mb: { md: 2 },
          maxWidth: { xs: 340, md: 420 },
          px: 1,
          display: compact ? 'none' : 'block',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: tokens.onPrimary,
            fontFamily: '"Fraunces", Georgia, serif',
            fontWeight: 650,
            letterSpacing: '-0.03em',
            mb: 1,
            fontSize: { xs: '1.45rem', sm: '1.65rem', md: '1.9rem', lg: '2.15rem' },
          }}
        >
          From signal to screen
        </Typography>
        <Typography
          sx={{
            color: tokens.onShell,
            lineHeight: 1.65,
            fontSize: { xs: '1rem', sm: '1.05rem', md: '1.1rem' },
          }}
        >
          Broadcast goes out — alerts land on your phone. Live updates in one
          place.
        </Typography>
      </Box>
    </Box>
  );
}
